/* unplugin-vue-components disabled */export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "page-title": (ctx) => {const { normalize: _normalize, plural: _plural } = ctx;return _plural([_normalize(["Manage Your Games"]), _normalize(["Playgama"])])},
        "page-description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Develop, upload, and manage your HTML5 games with Playgama. Track moderation, view stats, and maximize your game revenue."])}
      }
    }
  })
}
